import { API_URL } from "@/env";
import auth0Config from "../auth0Config";
import appSettings from "../appSettings";


const cspSources = {
    default: ["'self'"],
    font: ["https://fonts.gstatic.com", "https://fonts.googleapis.com", "https://cdn.jsdelivr.net"],
    style: ["https://fonts.googleapis.com", "https://cdn.jsdelivr.net", "https://cdn.auth0.com"],
    script: ["https://cdn.jsdelivr.net", "https://cdn.auth0.com"],
    img: ["https://cdn.auth0.com"],
    connect: [API_URL, "https://*.launchdarkly.com", `https://${auth0Config.domain}`, "https://cdn.auth0.com",
      `https://api-${appSettings.sendBirdAppId.toLowerCase()}.sendbird.com`,
      `wss://ws-${appSettings.sendBirdAppId.toLowerCase()}.sendbird.com`,
    ],
    frame: [`https://${auth0Config.domain}`]
}

export default {
  getContentSecurityPolicy: () => {    
    let policies = [];
    policies.push("default-src 'self'");
    policies.push(`font-src 'self' ${cspSources.font.join(' ')}`);
    policies.push(`script-src 'self' ${cspSources.script.join(' ')}`);
    policies.push(`style-src 'self' ${cspSources.style.join(' ')}`);
    policies.push(`img-src 'self' ${cspSources.img.join(' ')}`);
    policies.push(`connect-src 'self' ${cspSources.connect.join(' ')}`);
    return policies.join('; ');
  },
};
